// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2decce1d","header":"_5a522e91","welcomeMessage":"_256a84ff"};